<template>
  <span :style="style">
    <user-avatar v-for="user in users" :key="user.id" :userInfo="user" />
  </span>
</template>

<script>
import UserAvatar from './UserAvatar.vue'
export default {
  props: {
    users: {
      type: Array,
      required: true
    },
    spacing: {
      type: Number,
      defualt: 5
    }
  },
  components: {
    UserAvatar
  },
  methods: {
    style(idx) {
      return {
        paddingLeft: idx === 0 ? 0 : `${this.space}px`
      }
    }
  }
}
</script>
